import styled from "styled-components";
import bgImgDesktop from '../../assets/images/BGF2024_bg1.jpg'
import bgImgMobile from '../../assets/images/BGF2024_bg2_mobile.webp'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  section:nth-of-type(1) {
    background: url(${bgImgDesktop}) 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  section:nth-of-type(2) {
    background: #9d7bc9;
    top: 100%;
  }

  .float-button {
    display: inline-block;
    padding: 15px 25px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #00c1c4;
    border: none;
    border-radius: 15px;
    box-shadow: 0 9px #999;
    align-itens: center;
  }
  
  .float-button:hover {background-color: #9d7bc9}
  
  .float-button:active {
    background-color: #9d7bc9;
    box-shadow: 0 5px #666;
    transform: translateY(4px);
  }

  .float{
    position:fixed;
    width:60px;
    height:60px;
    bottom:10%;
    right:20%;
    background-color:#0C9;
    color:#FFF;
    border-radius:50px;
    text-align:center;
    box-shadow: 2px 2px 3px #999;
  }
  
  .my-float{
    margin-top:22px;
  }

  .cover {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
  }

  @media only screen and (max-width: 800px) {
    section:nth-of-type(1) {
      background: url(${bgImgMobile}) no-repeat 50%;
      background-size: 100vh;
    }

    .float-button {
      display: inline-block;
      padding: 15px 25px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      text-align: center;
      text-decoration: none;
      outline: none;
      color: #fff;
      background-color: #00c1c4;
      border: none;
      border-radius: 15px;
      box-shadow: 0 9px #999;
    }
    
    .float-button:hover {background-color: #9d7bc9}
    
    .float-button:active {
      background-color: #9d7bc9;
      box-shadow: 0 5px #666;
      transform: translateY(4px);
    }
  
    .float{
      position:fixed;
      width:40px;
      height:40px;
      bottom:10%;
      right:55%;
      background-color:#0C9;
      color:#FFF;
      border-radius:50px;
      text-align:center;
      box-shadow: 2px 2px 3px #999;
    }
    
    .my-float{
      margin-top:22px;
    }
  }
  
  @media only screen and (max-width: 853px) {
    section:nth-of-type(1) {
      background: url(${bgImgMobile}) no-repeat 50%;
      background-size: 100vh;
    }

    .float-button {
      display: inline-block;
      padding: 15px 25px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      text-align: center;
      text-decoration: none;
      outline: none;
      color: #fff;
      background-color: #00c1c4;
      border: none;
      border-radius: 15px;
      box-shadow: 0 9px #999;
    }
    
    .float-button:hover {background-color: #9d7bc9}
    
    .float-button:active {
      background-color: #9d7bc9;
      box-shadow: 0 5px #666;
      transform: translateY(4px);
    }
  
    .float{
      position:fixed;
      width:40px;
      height:40px;
      bottom:10%;
      right:55%;
      background-color:#0C9;
      color:#FFF;
      border-radius:50px;
      text-align:center;
      box-shadow: 2px 2px 3px #999;
    }
    
    .my-float{
      margin-top:22px;
    }
  }
`;

export const Section = styled.section`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  left: 0;
  transition-delay: 0.5s;
`

export const FormContainer = styled.div`
  width: 90%;
  max-width: 400px;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`

export const StyledInput = styled.input`
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export const CheckboxContainer = styled.div`
  margin-bottom: 5px;
  margin-top: 10px;

  h2 {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: normal;
  }
`;

export const CheckboxLabel = styled.label`
  display: block;
  margin-bottom: 5px;
`;

export const CheckboxLabelAlt = styled.label`
  display: inline-block;
  margin-bottom: 5px;
  margin-right: 5px;
`;

export const TermsField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: #808080;
  font-weight: 400;
  gap: 1em;
  font-size: 14px;

  div {
    display: flex;
    flex-direction: row;
    gap: 5px;
    justify-content: center;
    align-items: flex-start;
  }

  input {
    height: 16px;
    width: 16px;
    max-width: 16px;
    min-width: 16px;
    max-height: 16px;
    min-height: 16px;
    vertical-align: middle;
  }

  p {
    margin: 0;
    padding: 0;
    border: 0;
  }

  span {
    text-decoration: underline;
    cursor: pointer;
  }
`;
